module.exports = __webpack_public_path__ + "img/mission-diversity-ethics.jpg?9e11ec9ea4fce316f8a78cd257880cdd";